import { getAirportTimezone, getOffset, getTime, getTimeInTimezone } from 'helper/date';
import { FlightRouteCardDetailsProps } from './FlightRouteCardDetails.intertface';
import * as S from './FlightRouteCardDetails.styles';

const FlightRouteCardDetails = ({ time, airport }: FlightRouteCardDetailsProps) => {
  return (
    <>
      <S.TimeBlock>
        {getTimeInTimezone(time, getAirportTimezone(airport.locationCode))} {airport.locationCode}
      </S.TimeBlock>
      <S.CityBlock>{airport.locationName}</S.CityBlock>
    </>
  );
};

export default FlightRouteCardDetails;
